import { createAsyncThunk } from "@reduxjs/toolkit";

import { apiProxyRequest } from "Api/apiProxyRequest";

import { User } from "../projectAccess.types";

import type { ProjectAccess } from "@packages/client";

interface UpdateProjectAccessCallback {
  projectId: string;
  access: ProjectAccess;
  organizationId: string;
  role: User["role"];
}

export const updateProjectAccessThunk = createAsyncThunk(
  "app/project/access/update",
  async (
    { projectId, access, role }: UpdateProjectAccessCallback,
    { rejectWithValue }
  ) => {
    if (!projectId) return false;

    try {
      const result = await access.update({ role });
      const newAccess = await result?.getEntity();
      return newAccess;
    } catch (err: unknown) {
      // With the organizations update, certain users may have the edit
      // permission but the edit link won't be available so the code above will
      // fail but calling directly to the patch endpoint should work. if it
      // doesnt, we fail as usual :)
      if (err instanceof Error && err.message === "Not allowed to edit") {
        try {
          // Typing this is a nightmare, so I wont even try
          const result = await apiProxyRequest<any>(
            `/projects/${projectId}/access/${access.id}`,
            "PATCH",
            { role }
          );
          return result._embedded.entity;
        } catch {
          return rejectWithValue({ errors: err });
        }
      }
      return rejectWithValue({ errors: err });
    }
  }
);
